import React from 'react';
import {Link} from 'react-router-dom';

import Authenticated from 'Components/Layouts/Authenticated';
import {PrimaryButton} from 'Components/Button';
import MailLink from 'Components/Utilities/MailLink';

export default class GettingReady extends React.Component {
    /**
     * @method render
     * @return {*}
     */
    render () {
        return (
            <Authenticated>
                <h1 className="mb-2 text-2xl font-bold">
                    Getting Ready
                </h1>

                <div className="text-center my-12">
                    <p>
                        This year we will be celebrating our successes virtually from the comfort of our own homes.
                        <br/>
                        Please take the following steps to ensure you are prepared for the live event.
                    </p>

                    <p className="font-bold text-lg mt-8">
                        VIEWING THE STREAM
                    </p>
                    <p className="mt-2">
                        Please visit the test stream page to check that you can view the event stream.
                    </p>

                    <div className="mt-8">
                        <Link to="/main-stage/test-stream">
                            <PrimaryButton
                                text="Test Stream"
                            />
                        </Link>
                    </div>

                    <p className="font-bold text-lg mt-10">
                        HEARING THE STREAM
                    </p>
                    <p className="mt-2">
                        To manage the volume on the event stream hover over the middle of the event stream window, 
                        you will be able to see a volume bar in the bottom right corner of the stream.
                    </p>

                    <p className="font-bold text-lg mt-8">
                        BUFFERING ON THE EVENT STREAM
                    </p>
                    <p className="mt-2">
                        If the web stream buffers, this will be due to your local connectivity. 
                        Don’t panic if you miss any of the Live Show, it is being recorded and 
                        after the event has finished will be made available for you to watch 
                        again via the On-Demand page.
                    </p>

                    <p className="font-bold text-lg mt-8">
                        EVENT SUPPORT
                    </p>
                    <p className="mt-2">
                        If you require any assistance with accessing the site before or during the event, please email us at{" "}
                        <MailLink/>
                    </p>

                    <p className="font-bold text-lg mt-8">
                        TAKING PART
                    </p>
                    <p className="mt-2">
                        You can interact with the event using emoji reactions and comments. 
                        This can be done by using the controls on the Live Show page. 
                        Emojis and comments will be visible to everyone watching the event. 
                        Comments will be moderated so as always please be kind and bring only positive vibes. 
                        Also, do not forget to check-out the Activity Wall to see what your consultants are up to.
                    </p>

                    <p className="font-bold text-lg mt-8">
                        TECHNICAL
                    </p>
                    <p className="mt-2">
                        On the day of the event, to maximise your viewing experience, please take the following steps:
                    </p>
                    <p className="mt-2">
                        1. View the stream on Firefox, Safari or Chrome browsers. Do not use Internet Explorer.
                    </p>
                    <p className="mt-2">
                        2. If you're using a desktop device please plug the device directly into your router, if possible.
                    </p>
                    <p className="mt-2">
                        3. Turn off all other software on your devices - for laptop devices this means Teams, Google Updates, Zoom etc.
                    </p>
                    <p className="mt-2">
                        4. Politely ask residents in your home to minimise their use of internet where necessary.
                    </p>

                    <div className="mt-8">
                        <Link to="/">
                            <PrimaryButton
                                text="Go to home"
                            />
                        </Link>
                    </div>
                </div>
            </Authenticated>
        );
    }
}
